import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto auto auto 1fr;
`;

export const Content = styled.div`
  overflow: auto;
  overflow-y: overlay;
  height: 100%;
  padding-bottom: 10px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Header = styled.div`
  width: 100%;
  padding-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Title = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;

  &.headTitle {
    color: #161a30;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterButton = styled.button`
  border-radius: 8px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 36px;
  outline: 0;
  margin-right: 8px;
`;

export const AddButton = styled.button`
  border-radius: 8px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 36px;
  outline: 0;
`;

export const AddButtonText = styled.div`
  margin-left: 10px;
  color: #474d66;
  font-size: 14px;
`;

export const Spacing = styled.div`
  margin: 0 40px;
`;

export const Divider = styled.div`
  width: 100%;
  background: #e6e8f0;
  height: 1px;
  margin-bottom: 8px;
`;

export const Heading = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  padding-bottom: 8px;
`;

export const Direction = styled.div`
  margin-left: 8px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const ColumnName = styled.div`
  font-size: 12px;
  color: #8f95b2;
  font-weight: 500;
`;

export const Line = styled.div`
  width: 100%;
  align-items: center;
  display: grid;
  grid-template-columns: 2fr 3fr 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  padding: 18px 0 16px 0;
  border-bottom: 1px solid #e6e8f0;
  padding-left: 5px;
`;

interface ILineText {
  limitOfLines?: number;
}

export const LineText = styled.div<ILineText>`
  color: #474d66;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const NoText = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-style: italic;
`;

export const InputContainer = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  position: relative;
`;

interface IInputSearch {
  search?: boolean;
  clear?: boolean;
}

export const InputSearch = styled.input<IInputSearch>`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }

  ${({ search }) =>
    search &&
    css`
      padding-right: 66px;
    `}
  ${({ clear }) =>
    clear &&
    css`
      padding-right: 36px;
    `}
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const SearchClear = styled.div`
  position: absolute;
  right: 16px;
  cursor: pointer;
`;

export const SearchButton = styled.div`
  position: absolute;
  right: 12px;
  font-size: 12px;
  color: #1371fe;
  cursor: pointer;
`;

export const MenuImg = styled.img`
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 32px;
  width: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const MenuDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const SmallerText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #474d66;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinkText = styled.a`
  color: #1371fe;
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
`;
